import React, { useState } from "react";

import * as R from "ramda";

import camelCase from "camel-case";

import Modal from "react-modal";

import { handleResponse } from "src/sdk";

import { Login } from "src/banking/authentication";

import { Flex, PageContainer } from "src/components";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const getInitialState = body => {
  if (body) {
    const { data, links } = handleResponse({
      data: body,
    });

    const initialState = R.evolve({
      state: camelCase,
    })(data);

    return {
      ...initialState,
      links,
    };
  }
};

export const AuthenticationError = ({ error, onCancel, resolveError }) => {
  const [open, setOpen] = useState(true);
  const body = R.path(["extensions", "response", "body"], error);

  const initialState = getInitialState(body);

  const stateKey = R.propOr("entry", "state", initialState);

  const handleComplete = () => {
    setOpen(false);
    if (resolveError) {
      resolveError();
    }
  };

  return (
    <Modal
      isOpen={open}
      style={customModalStyles}
      onRequestClose={() => onCancel(stateKey)}
    >
      <PageContainer
        themeName="green"
        roundTopCorners={false}
        isFullPage={true}
        pb={0}
      >
        <Flex width={["100%", 500]} flexDirection="column">
          <Login initialState={initialState} onComplete={handleComplete} />
        </Flex>
      </PageContainer>
    </Modal>
  );
};

const AuthenticationErrors = ({ errors, onCancel }) => {
  return errors.map((error, index) => (
    <AuthenticationError
      error={error}
      key={`${index}-${error.message}`}
      onCancel={onCancel}
    />
  ));
};

export default AuthenticationErrors;



// WEBPACK FOOTER //
// ./src/graphql/AuthenticationErrors.js